module.exports = __webpack_public_path__ + "static/media/41.87de7c6a.jpg";